import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!url || !key) {
  // Fail loudly at load rather than as a confusing 401 on the first request.
  throw new Error(
    "VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY must be set at build time",
  );
}

export const supabase = createClient(url, key, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});

/** Which sign-in providers the project has switched on, from Supabase's
 *  public settings endpoint — or null if that could not be read (slow or
 *  blocked network, privacy extension). Null means "unknown", never "off". */
export async function enabledProviders(): Promise<Record<string, boolean> | null> {
  try {
    const r = await fetch(`${url}/auth/v1/settings`, { headers: { apikey: key } });
    if (!r.ok) return null;
    const body = await r.json();
    return (body?.external ?? null) as Record<string, boolean> | null;
  } catch {
    return null;
  }
}
